import { PrimitiveType } from "@buildwithflux/models";
import { approxAABoundingBox } from "./approxAABoundingBox";
import { chainCompoundPrimitiveTransforms } from "./utils";
function isShapeFullyContained(primitiveA, primitiveB) {
    const bbA = approxAABoundingBox(primitiveA);
    const bbB = approxAABoundingBox(primitiveB);
    return bbB.maxX <= bbA.maxX && bbB.minX >= bbA.minX && bbB.maxY <= bbA.maxY && bbB.minY >= bbA.minY;
}
/** Given a complex primitive, returns the outer primitive if possible */
export function outerPrimitive(primitive) {
    if (primitive.type === PrimitiveType.Union || primitive.type === PrimitiveType.Difference) {
        const fullyContained = isShapeFullyContained(primitive.primitiveA, primitive.primitiveB);
        if (fullyContained) {
            return outerPrimitive(chainCompoundPrimitiveTransforms(primitive)[0]);
        }
        else {
            return null;
        }
    }
    return primitive;
}
//# sourceMappingURL=outerPrimitive.js.map